<input [(ngModel)]="hamburgerOpen" type="checkbox" id="hamburger" name="hamburger" (change)="openHamburger()" />
<label for="hamburger" class="hamburger hamburger--spring" [matTooltip]="'Open menu (Alt+Shift+M)'" matTooltipShowDelay="500">
  <div class="hamburger-box">
    <div class="hamburger-inner"></div>
  </div>
</label>
<div class="menu-container" [ngClass]="[hamburgerOpen ? 'hamburger-open' : 'hamburger-closed']" #burgerContainer>
  <div class="menu"></div>
  <h1>
    <a [routerLink]="homeRoute" [matTooltip]="homeTooltip" matTooltipShowDelay="500">{{ menuTitle }}</a>
  </h1>
  <ul class="links">
    @for (item of menuItems; track $index) {
    <li [ngClass]="item.customClass">
      <span>
        <a
          [class.current-section]="item.isCurrentSection"
          [class.disabled]="item.disabled"
          [matTooltip]="item.tooltip"
          matTooltipShowDelay="500"
          (click)="onMenuItemClick(item)"
        >
          @if (item.icon) {
          <mat-icon [fontIcon]="item.icon.name" [ngClass]="item.icon.class"></mat-icon>
          } @if (item.imageIcon) {
          <img [src]="item.imageIcon" [matTooltip]="item.tooltip" matTooltipShowDelay="500" />
          }
          {{ item.label }}
          @if (item.iconAfter) {
          <mat-icon [fontIcon]="item.iconAfter.name" [ngClass]="item.iconAfter.class"></mat-icon>
          } @if (item.showNewTabIcon) {
          <mat-icon class="new-tab" fontIcon="open_in_new" [matTooltip]="'Opens in a new tab'" matTooltipShowDelay="500"> </mat-icon>
          } @if (item.subItems) {
          <mat-icon class="expand-icon" [class.expanded]="item.expanded" fontIcon="expand_more"> </mat-icon>
          }
        </a>
      </span>
      @if (item.subItems && item.expanded) {
      <ul class="sub-items">
        @for (subItem of item.subItems; track $index) {
        <li [ngClass]="subItem.customClass">
          <span>
            <a
              [class.current-section]="subItem.isCurrentSection"
              [class.disabled]="subItem.disabled"
              [matTooltip]="subItem.tooltip"
              matTooltipShowDelay="500"
              (click)="onMenuItemClick(subItem)"
            >
              @if (subItem.icon) {
              <mat-icon [fontIcon]="subItem.icon.name" [ngClass]="subItem.icon.class"></mat-icon>
              }
              {{ subItem.label }}
              @if (subItem.iconAfter) {
              <mat-icon [fontIcon]="subItem.iconAfter.name" [ngClass]="subItem.iconAfter.class"></mat-icon>
              } @if (subItem.showNewTabIcon) {
              <mat-icon class="new-tab" fontIcon="open_in_new" [matTooltip]="'Opens in a new tab'" matTooltipShowDelay="500"> </mat-icon>
              }
            </a>
          </span>
        </li>
        }
      </ul>
      }
    </li>
    }
  </ul>
</div>
